import { z } from "zod";

/**
 * Hook para criar o schema de validação do formulário de Self Service
 * @param {Object} intl - Objeto de internacionalização do react-intl
 * @returns {z.ZodSchema} Schema de validação do Zod
 */
export const useAccessCodeValidationSchema = (intl) => {
  return z.object({
    accessCode: z.string().min(1, "Este campo é obrigatório").trim(),
    totemPosition: z
      .string()
      .optional()
      .refine((val) => val === undefined || val.trim().length > 0, {
        message: "Este campo é obrigatório",
      }),
  });
};
